<template>
  <div class="landing-exit">&nbsp;</div>
</template>
